"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Activities = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _FemaGoModal = _interopRequireDefault(require("../modal/FemaGoModal"));
var _semanticUiReact = require("semantic-ui-react");
var _FormControls = require("../FormControls");
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = require("../../../../common/constants");
var _FemaGoTable = _interopRequireDefault(require("../tables/femaGoTable/FemaGoTable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var maxAllowedActivities = 3;
var MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
  DELETE: 'delete'
};
var Activities = /*#__PURE__*/function (_React$Component) {
  _inherits(Activities, _React$Component);
  var _super = _createSuper(Activities);
  function Activities(props) {
    var _this;
    _classCallCheck(this, Activities);
    _this = _super.call(this, props);
    _this.sortActivitiesByTier = function (acts, tiers) {
      var actArray = [];
      if (acts !== undefined && acts.length > 0) {
        var i = 0;
        acts.forEach(function (item) {
          i++;
          if (item !== undefined) {
            actArray.push({
              key: item.key,
              act: item.act,
              name: item.name,
              description: item.description,
              tierText: tiers[i - 1].text,
              subText: tiers[i - 1].subText,
              tier: tiers[i - 1].tier,
              subActs: item.subActs
            });
          }
        });
      }
      return actArray;
    };
    _this.getChosen = function () {
      var acts = _this.sortActivitiesByTier(_this.state.chosenActivities, _constants.activityTier);
      return _lodash.default.clone(acts);
    };
    _this.updateActivities = function (chosen) {
      var updateActivities = _lodash.default.map(chosen, function (activity) {
        return activity !== undefined ? {
          act: activity.act,
          description: activity.description,
          key: activity.key,
          name: activity.name,
          subActs: _lodash.default.filter(activity.subActs, function (item) {
            return item.checked === true;
          }),
          subText: activity.subText,
          tier: activity.tier,
          tierText: activity.tierText
        } : undefined;
      });
      _this.setState({
        chosenActivities: updateActivities
      });
      var _this$props = _this.props,
        entityDataPath = _this$props.entityDataPath,
        entityType = _this$props.entityType,
        readOnly = _this$props.readOnly;
      _this.props.saveEntityData(entityDataPath, entityType, updateActivities);
    };
    _this.handleRemoveActivity = function (index) {
      var chosen = _this.getChosen();
      chosen.splice(index, 1);
      var sortedActs = _this.sortActivitiesByTier(chosen, _constants.activityTier);
      _this.setState({
        chosenActivities: sortedActs,
        activities: sortedActs
      });
      _this.updateActivities(sortedActs);
    };
    _this.handleBlur = function () {
      var chosen = _this.getChosen();
      var _this$props2 = _this.props,
        entityDataPath = _this$props2.entityDataPath,
        entityType = _this$props2.entityType;
      _this.props.saveEntityData(entityDataPath, entityType, chosen);
    };
    _this.getName = function (id) {
      var itemCodes = _this.props.context.loadItemCodes;
      return _lodash.default.filter(itemCodes, function (item) {
        return Number(item.itemCode) === Number(id);
      });
    };
    _this.getId = function (name) {
      var acts = _this.state.primaryActivities;
      var id = _lodash.default.filter(acts, function (act) {
        return act.text === name;
      });
      return id !== undefined && id[0] !== undefined ? id[0].key : 'no name found';
    };
    _this.handleChangeSelectedActivity = function (e) {
      _this.setState({
        selectedPrimeName: e.target.value
      });
      var activity = _this.state.activitiesList[e.target.value];
      var subActivities = _lodash.default.map(activity, function (act) {
        return {
          key: act.itemCode,
          psi: 'N/A',
          checked: false,
          description: act.name
        };
      });
      _this.setState({
        subActivities: subActivities
      });
    };
    _this.handleChangeSelectedSubsList = function (key) {
      _this.state.subActivities.forEach(function (subAct) {
        if (subAct.key === key) {
          subAct.checked = !subAct.checked;
        }
      });
      _this.setState({
        updater: ''
      });
    };
    _this.renderDeleteActivityModal = function () {
      var applicationType = _this.props.applicationType;
      return /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
        parseHtml: "true",
        title: "Delete Activity Modal",
        size: "tiny",
        type: "alert",
        open: _this.state.openModal === MODALS.DELETE,
        buttonText: "Delete",
        confirmAction: function confirmAction() {
          _this.handleRemoveActivity(_this.state.selectedIndex);
          _this.setState({
            openModal: MODALS.NONE,
            selectedIndex: 0
          });
        },
        cancelAction: function cancelAction() {
          return _this.setState({
            openModal: MODALS.NONE
          });
        }
      }, applicationType === '231' ? 'Are you sure you want to delete the activity?' : 'Are you sure you want to delete?');
    };
    _this.renderActivitySelectTable = function () {
      var _this$state = _this.state,
        primaryActivities = _this$state.primaryActivities,
        subActivities = _this$state.subActivities;
      var selectedAct = [{
        key: 'number',
        value: 'Select an activity',
        text: 'Select an activity'
      }];
      var subActs = subActivities;
      selectedAct = selectedAct.concat(primaryActivities);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react.default.createElement(_FormControls.Select, {
        label: "Select activity type",
        id: "activityType",
        name: "activityType",
        options: selectedAct,
        value: undefined,
        handleBlur: _this.handleBlur,
        handleChange: _this.handleChangeSelectedActivity
      }), /*#__PURE__*/_react.default.createElement("h4", null, "Select subactivity type(s)"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default, {
        type: "entry",
        scrollable: 100
      }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Header, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Select"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "Subactivity name"), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, null, "PSI"))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Body, null, _lodash.default.map(subActs, function (_ref) {
        var checked = _ref.checked,
          description = _ref.description,
          psi = _ref.psi,
          key = _ref.key;
        return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
          key: key
        }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.CheckboxCell, {
          className: "checked",
          title: "Checked",
          checked: checked,
          width: 1,
          handleChange: function handleChange() {
            _this.handleChangeSelectedSubsList(key);
          }
        }), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
          value: description,
          title: "Subactivity Name",
          id: description,
          width: 10,
          name: "description",
          handleChange: function handleChange() {},
          handleBlur: function handleBlur() {},
          maxLength: 501
        }, description), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
          value: psi,
          title: "PSI",
          width: 1,
          name: "number"
        }, psi));
      })))));
    };
    _this.createSubActListString = function (arr) {
      var subactivitiesString = '';
      subactivitiesString = _lodash.default.join(_lodash.default.filter(arr, {
        checked: true
      }).map(function (act) {
        return act.description;
      }), ', ');
      return subactivitiesString;
    };
    _this.renderAvailable = function () {
      var chosenActivities = _this.state.chosenActivities;
      var activities = chosenActivities;
      var actArray = [];
      activities.forEach(function (act) {
        //act !== undefined ? actArray.push(act) : '';
        if (act !== undefined) actArray.push(act);
      });
      var renderActivities = _this.sortActivitiesByTier(actArray, _constants.activityTier);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, renderActivities !== undefined && renderActivities.length > 0 && renderActivities[0] !== undefined && renderActivities && _lodash.default.map(renderActivities, function (term, index) {
        return term !== undefined ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card, {
          fluid: true,
          key: index
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
          celled: "internally",
          fluid: true
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
          width: 14
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
          celled: "internally",
          fluid: true,
          row: 2
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react.default.createElement("strong", null, term.tierText), /*#__PURE__*/_react.default.createElement("div", null, term.act))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
          celled: "internally",
          fluid: true,
          row: 2
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react.default.createElement("strong", null, term.subText), /*#__PURE__*/_react.default.createElement("div", null, term.subActs != undefined ? _this.createSubActListString(term.subActs) : '')))), !_this.props.readOnly ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
          width: 2
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
          columns: 1
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
          width: "8"
        }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "pencil",
          style: {
            display: 'inline',
            fontWeight: 'bold'
          },
          color: "blue"
        }), /*#__PURE__*/_react.default.createElement("a", {
          title: "Edit Activity",
          className: "editIcon",
          href: "#".concat(index),
          id: index,
          onClick: function onClick() {
            return _this.setState({
              selectedPrimeName: term.act,
              subActivities: _this.getSubs(term.act),
              selectedActivity: term,
              selectedIndex: index,
              openModal: MODALS.EDIT
            });
          },
          color: "blue"
        }, "Edit"), index === 0 ? '' : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "delete",
          style: {
            display: 'inline',
            fontWeight: 'bold'
          },
          color: "blue"
        }), /*#__PURE__*/_react.default.createElement("a", {
          title: "Delete Activity Icon",
          className: "deleteActivityIcon",
          href: "#",
          onClick: function onClick(e) {
            e.preventDefault();
            _this.setState({
              selectedIndex: index,
              openModal: MODALS.DELETE
            });
          },
          color: "blue"
        }, "Delete"))))) : null)) : '';
      })), /*#__PURE__*/_react.default.createElement("br", null), !_this.props.readOnly && renderActivities !== undefined && renderActivities.length < maxAllowedActivities ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        width: 10
      }, renderActivities.length === 0 ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
        basic: true,
        primary: true,
        href: "#",
        title: "Create Primary Activity",
        onClick: function onClick() {
          _this.setState({
            selectedIndex: renderActivities.length,
            chosenActivities: renderActivities,
            subActivities: [],
            selectedPrimeName: '',
            openModal: MODALS.CREATE
          });
          _this.renderActivitySelectTable();
        }
      }, "+ Add a ", _constants.activityTier[renderActivities.length].tier, " activity") : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
        basic: true,
        primary: true,
        href: "#",
        title: "Create Additional Activities",
        onClick: function onClick() {
          _this.setState({
            selectedIndex: activities.length,
            chosenActivities: renderActivities,
            subActivities: [],
            selectedPrimeName: '',
            openModal: MODALS.CREATE
          });
          _this.renderActivitySelectTable();
        }
      }, "+ Add a ", _constants.activityTier[renderActivities.length].tier, " activity")) : '');
    };
    _this.state = {
      selectedPrime: '',
      selectedPrimeName: '',
      selectedActivity: {
        key: 0,
        act: '',
        name: '',
        description: '',
        tierText: '',
        subText: '',
        tier: '',
        subActs: []
      },
      selectedSubActivities: [],
      chosenActivities: [],
      activitiesList: [],
      primaryActivities: [],
      subActivities: [],
      activities: [],
      openModal: MODALS.NONE,
      selectedIndex: -1,
      updater: undefined
    };
    return _this;
  }
  _createClass(Activities, [{
    key: "generateSubactivityList",
    value: function generateSubactivityList(applicationType) {
      var _this2 = this;
      var applicationTypActivities = this.props.applicationTypeActivities;
      var acts = applicationTypActivities.filter(function (obj) {
        return Number(obj.applicationTypeId) === Number(applicationType);
      });
      if (acts !== undefined && acts[0] !== undefined) {
        var test = _lodash.default.map(acts[0].items, function (obj2) {
          var prelimSubActs = _lodash.default.map(obj2.children, function (x) {
            return _this2.getName(x);
          });
          var subActivityList = _lodash.default.flatMap(prelimSubActs, function (obj) {
            return {
              itemCode: obj[0].itemCode,
              name: obj[0].name,
              description: obj[0].description
            };
          });
          return {
            primaryActivity: _this2.getName(obj2.itemCode),
            subActivityList: subActivityList
          };
        });
        var allActs = _lodash.default.map(test, function (entry) {
          return {
            key: entry.primaryActivity[0].itemCode,
            value: entry.subActivityList,
            text: entry.primaryActivity[0].name
          };
        });
        var primes = _lodash.default.map(allActs, function (entry) {
          return {
            key: entry.key,
            value: entry.text,
            text: entry.text
          };
        });
        var dict = {};
        allActs.forEach(function (x) {
          return dict[x.text] = x.value;
        });
        var chosenAct = this.state.chosenActivities;
        if (this.state.openModal === MODALS.CREATE) {
          chosenAct.forEach(function (x) {
            if (x !== undefined) {
              primes = primes.filter(function (obj) {
                return obj.text !== x.act;
              });
            }
          });
        }
        this.setState({
          primaryActivities: primes
        });
        this.setState({
          activitiesList: dict
        });
        return allActs;
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var props = this.props.applicationType;
      if (props !== nextProps.applicationType) {
        this.setState({
          activities: [],
          chosenActivities: []
        });
        this.updateActivities([]);
        this.generateSubactivityList(nextProps.applicationType);
      } else if (props !== undefined) {
        this.generateSubactivityList(props);
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var activities = this.state.chosenActivities;
      var retrievedAndNewActivities = activities.concat(this.props.activities);
      this.setState({
        chosenActivities: retrievedAndNewActivities,
        activities: retrievedAndNewActivities
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "renderEditActivityModal",
    value: function renderEditActivityModal() {
      var _this3 = this;
      var _this$state2 = this.state,
        selectedActivity = _this$state2.selectedActivity,
        selectedIndex = _this$state2.selectedIndex,
        openModal = _this$state2.openModal,
        selectedPrimeName = _this$state2.selectedPrimeName,
        subActivities = _this$state2.subActivities;
      var chosen = this.getChosen();
      var tier = selectedIndex < 0 ? '' : _constants.activityTier[selectedIndex].tier;
      var action = openModal === 'create' ? 'Add ' : 'Update ';
      var buttonText = action + 'selected activities';
      var title = action + tier + ' activities';
      selectedActivity.tier = tier;
      return /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
        parseHtml: "true",
        title: title,
        size: "large",
        open: this.state.openModal === MODALS.EDIT || this.state.openModal === MODALS.CREATE,
        disableButton: _lodash.default.isEmpty(selectedPrimeName) || selectedPrimeName === 'Select an activity',
        buttonText: buttonText,
        confirmAction: function confirmAction() {
          var subs = subActivities.filter(function (obj) {
            return obj.checked === true;
          });
          selectedActivity.act = selectedPrimeName;
          selectedActivity.subActs = subs;
          selectedActivity.key = _this3.getId(selectedActivity.act);
          selectedActivity.tierText = selectedIndex < 0 ? '' : _constants.activityTier[selectedIndex].text;
          selectedActivity.subText = selectedIndex < 0 ? '' : _constants.activityTier[selectedIndex].subText;
          chosen[selectedIndex] = selectedActivity;
          _this3.setState({
            chosenActivities: chosen,
            activities: chosen,
            openModal: MODALS.NONE
          });
          _this3.updateActivities(chosen);
        },
        cancelAction: function cancelAction() {
          return _this3.setState({
            openModal: MODALS.NONE
          });
        }
      }, this.renderActivitySelectTable());
    }
  }, {
    key: "getSubs",
    value: function getSubs(act) {
      var activity = this.state.activitiesList[act];
      var subActivities = _lodash.default.map(activity, function (obj) {
        return {
          key: obj.itemCode,
          psi: obj.name,
          checked: false,
          description: obj.name
        };
      });
      return subActivities;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        questionText = _this$props3.questionText,
        guidance = _this$props3.guidance,
        applicationTypeActivities = _this$props3.applicationTypeActivities;
      var dependencies = applicationTypeActivities;
      return dependencies === undefined ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Loader, {
        active: true
      }, "Loading...") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "questionText"
      }, questionText), /*#__PURE__*/_react.default.createElement("div", {
        className: "guidance"
      }, guidance), this.renderEditActivityModal(), this.renderDeleteActivityModal(), this.renderAvailable(), /*#__PURE__*/_react.default.createElement("br", null));
    }
  }]);
  return Activities;
}(_react.default.Component);
exports.Activities = Activities;
var _default = Activities;
exports.default = _default;